import React, { useState, useImperativeHandle } from 'react';
import { ITEM_ELEMENT_NUMBER, ITEM_HEIGHT } from '../constants';
import { useMemoizedFn } from 'ahooks';
import { useContext } from '../context';

interface DropdownRenderProps {
  /** 菜单 */
  menu: any;
  /** 总高 */
  allHeight: number;
}

const DropdownRender = React.forwardRef<any, DropdownRenderProps>((props, ref) => {
  const { menu, allHeight } = props;
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(ITEM_ELEMENT_NUMBER);
  const { virtual } = useContext();
  const _virtual = typeof virtual === 'object' ? virtual : { itemSize: ITEM_HEIGHT };
  const { itemSize } = _virtual || {};
  const getItemStyle = (i: number) => {
    return {
      position: 'absolute',
      top: itemSize * i,
      height: itemSize,
      width: '100%',
    };
  };

  // 因为state会导致重新渲染，所以需要放在dropdownRender内部进行set，通过ref抛出
  /** 获取截取的开始位置和结束位置 */
  const setStartAndEndIndex = useMemoizedFn((scrollTop: number) => {
    // 滚动后显示在列表可视区中的第一个 item 的 index
    const showIndex = Number((scrollTop / itemSize).toFixed());

    const startIndex = showIndex - ITEM_ELEMENT_NUMBER < 0 ? 0 : showIndex - ITEM_ELEMENT_NUMBER / 2;
    const endIndex = showIndex + ITEM_ELEMENT_NUMBER;
    setStartIndex(startIndex);
    setEndIndex(endIndex);
  });

  useImperativeHandle(
    ref,
    () => ({
      setStartAndEndIndex,
    }),
    [],
  );

  return React.cloneElement(menu, {
    menuItems: menu.props.menuItems.slice(startIndex, endIndex).map((item, index) => {
      const realIndex = startIndex + Number(index);
      const style = getItemStyle(realIndex);
      if (item.key === 'NOT_FOUND') {
        // @ts-ignore
        delete style.height;
      }
      return React.cloneElement(item, {
        style: { ...item.props.style, ...style },
      });
    }),
    dropdownMenuStyle: {
      ...menu.props.dropdownMenuStyle,
      height: allHeight,
      maxHeight: allHeight,
      overflow: 'hidden',
    },
  });
});

export default DropdownRender;
